import { render } from "./TikuAdapterLayout.vue?vue&type=template&id=ed904708&scoped=true"
import script from "./TikuAdapterLayout.vue?vue&type=script&lang=js"
export * from "./TikuAdapterLayout.vue?vue&type=script&lang=js"

import "./TikuAdapterLayout.vue?vue&type=style&index=0&id=ed904708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed904708"]])

export default __exports__